import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { aiColors } from '../../../../ai-suite/theme';

/** A heading above a run of report cards. */
export const ReportHeading = memo(({ title }: { title: string }) => {
  const { rpx } = useResponsiveContext();
  return (
    <Typography.Text
      size={rpx(14)}
      bold
      color={aiColors.foreground}
      style={{ paddingHorizontal: rpx(4) }}
    >
      {title}
    </Typography.Text>
  );
});
